window.EliteERPContactCountries = [
  {
    "iso": "AF",
    "name": "Afghanistan",
    "dial": "+93"
  },
  {
    "iso": "AL",
    "name": "Albania",
    "dial": "+355"
  },
  {
    "iso": "DZ",
    "name": "Algeria",
    "dial": "+213"
  },
  {
    "iso": "AS",
    "name": "American Samoa",
    "dial": "+1684"
  },
  {
    "iso": "AO",
    "name": "Angola",
    "dial": "+244"
  },
  {
    "iso": "AI",
    "name": "Anguilla",
    "dial": "+1264"
  },
  {
    "iso": "AG",
    "name": "Antigua and Barbuda",
    "dial": "+1268"
  },
  {
    "iso": "AR",
    "name": "Argentina",
    "dial": "+54"
  },
  {
    "iso": "AM",
    "name": "Armenia",
    "dial": "+374"
  },
  {
    "iso": "AW",
    "name": "Aruba",
    "dial": "+297"
  },
  {
    "iso": "AU",
    "name": "Australia",
    "dial": "+61"
  },
  {
    "iso": "AT",
    "name": "Austria",
    "dial": "+43"
  },
  {
    "iso": "AZ",
    "name": "Azerbaijan",
    "dial": "+994"
  },
  {
    "iso": "BH",
    "name": "Bahrain",
    "dial": "+973"
  },
  {
    "iso": "BD",
    "name": "Bangladesh",
    "dial": "+880"
  },
  {
    "iso": "BB",
    "name": "Barbados",
    "dial": "+1246"
  },
  {
    "iso": "BY",
    "name": "Belarus",
    "dial": "+375"
  },
  {
    "iso": "BE",
    "name": "Belgium",
    "dial": "+32"
  },
  {
    "iso": "BZ",
    "name": "Belize",
    "dial": "+501"
  },
  {
    "iso": "BJ",
    "name": "Benin",
    "dial": "+229"
  },
  {
    "iso": "BM",
    "name": "Bermuda",
    "dial": "+1441"
  },
  {
    "iso": "BT",
    "name": "Bhutan",
    "dial": "+975"
  },
  {
    "iso": "BO",
    "name": "Bolivia",
    "dial": "+591"
  },
  {
    "iso": "BA",
    "name": "Bosnia and Herzegovina",
    "dial": "+387"
  },
  {
    "iso": "BW",
    "name": "Botswana",
    "dial": "+267"
  },
  {
    "iso": "BR",
    "name": "Brazil",
    "dial": "+55"
  },
  {
    "iso": "IO",
    "name": "British Indian Ocean Territory",
    "dial": "+246"
  },
  {
    "iso": "BN",
    "name": "Brunei",
    "dial": "+673"
  },
  {
    "iso": "BG",
    "name": "Bulgaria",
    "dial": "+359"
  },
  {
    "iso": "BF",
    "name": "Burkina Faso",
    "dial": "+226"
  },
  {
    "iso": "BI",
    "name": "Burundi",
    "dial": "+257"
  },
  {
    "iso": "KH",
    "name": "Cambodia",
    "dial": "+855"
  },
  {
    "iso": "CM",
    "name": "Cameroon",
    "dial": "+237"
  },
  {
    "iso": "CA",
    "name": "Canada",
    "dial": "+1"
  },
  {
    "iso": "CV",
    "name": "Cape Verde",
    "dial": "+238"
  },
  {
    "iso": "KY",
    "name": "Cayman Islands",
    "dial": "+1345"
  },
  {
    "iso": "CF",
    "name": "Central African Republic",
    "dial": "+236"
  },
  {
    "iso": "TD",
    "name": "Chad",
    "dial": "+235"
  },
  {
    "iso": "CL",
    "name": "Chile",
    "dial": "+56"
  },
  {
    "iso": "CN",
    "name": "China",
    "dial": "+86"
  },
  {
    "iso": "CX",
    "name": "Christmas Island",
    "dial": "+61"
  },
  {
    "iso": "CC",
    "name": "Cocos (Keeling) Islands",
    "dial": "+61"
  },
  {
    "iso": "CO",
    "name": "Colombia",
    "dial": "+57"
  },
  {
    "iso": "KM",
    "name": "Comoros",
    "dial": "+269"
  },
  {
    "iso": "CK",
    "name": "Cook Islands",
    "dial": "+682"
  },
  {
    "iso": "CR",
    "name": "Costa Rica",
    "dial": "+506"
  },
  {
    "iso": "HR",
    "name": "Croatia",
    "dial": "+385"
  },
  {
    "iso": "CU",
    "name": "Cuba",
    "dial": "+53"
  },
  {
    "iso": "CY",
    "name": "Cyprus",
    "dial": "+357"
  },
  {
    "iso": "CZ",
    "name": "Czech Republic",
    "dial": "+420"
  },
  {
    "iso": "CD",
    "name": "Democratic Republic of the Congo",
    "dial": "+243"
  },
  {
    "iso": "DK",
    "name": "Denmark",
    "dial": "+45"
  },
  {
    "iso": "DJ",
    "name": "Djibouti",
    "dial": "+253"
  },
  {
    "iso": "DM",
    "name": "Dominica",
    "dial": "+1767"
  },
  {
    "iso": "DO",
    "name": "Dominican Republic",
    "dial": "+1809"
  },
  {
    "iso": "TL",
    "name": "East Timor",
    "dial": "+670"
  },
  {
    "iso": "EC",
    "name": "Ecuador",
    "dial": "+593"
  },
  {
    "iso": "EG",
    "name": "Egypt",
    "dial": "+20"
  },
  {
    "iso": "SV",
    "name": "El Salvador",
    "dial": "+503"
  },
  {
    "iso": "GQ",
    "name": "Equatorial Guinea",
    "dial": "+240"
  },
  {
    "iso": "ER",
    "name": "Eritrea",
    "dial": "+291"
  },
  {
    "iso": "EE",
    "name": "Estonia",
    "dial": "+372"
  },
  {
    "iso": "ET",
    "name": "Ethiopia",
    "dial": "+251"
  },
  {
    "iso": "FK",
    "name": "Falkland Islands",
    "dial": "+500"
  },
  {
    "iso": "FO",
    "name": "Faroe Islands",
    "dial": "+298"
  },
  {
    "iso": "FM",
    "name": "Federated States of Micronesia",
    "dial": "+691"
  },
  {
    "iso": "FJ",
    "name": "Fiji",
    "dial": "+679"
  },
  {
    "iso": "FI",
    "name": "Finland",
    "dial": "+358"
  },
  {
    "iso": "FR",
    "name": "France",
    "dial": "+33"
  },
  {
    "iso": "GF",
    "name": "French Guiana",
    "dial": "+594"
  },
  {
    "iso": "PF",
    "name": "French Polynesia",
    "dial": "+689"
  },
  {
    "iso": "GA",
    "name": "Gabon",
    "dial": "+241"
  },
  {
    "iso": "GE",
    "name": "Georgia",
    "dial": "+995"
  },
  {
    "iso": "DE",
    "name": "Germany",
    "dial": "+49"
  },
  {
    "iso": "GH",
    "name": "Ghana",
    "dial": "+233"
  },
  {
    "iso": "GI",
    "name": "Gibraltar",
    "dial": "+350"
  },
  {
    "iso": "GR",
    "name": "Greece",
    "dial": "+30"
  },
  {
    "iso": "GL",
    "name": "Greenland",
    "dial": "+299"
  },
  {
    "iso": "GD",
    "name": "Grenada",
    "dial": "+1473"
  },
  {
    "iso": "GP",
    "name": "Guadeloupe",
    "dial": "+590"
  },
  {
    "iso": "GU",
    "name": "Guam",
    "dial": "+1671"
  },
  {
    "iso": "GT",
    "name": "Guatemala",
    "dial": "+502"
  },
  {
    "iso": "GG",
    "name": "Guernsey",
    "dial": "+44"
  },
  {
    "iso": "GN",
    "name": "Guinea",
    "dial": "+224"
  },
  {
    "iso": "GW",
    "name": "Guinea-Bissau",
    "dial": "+245"
  },
  {
    "iso": "GY",
    "name": "Guyana",
    "dial": "+592"
  },
  {
    "iso": "HT",
    "name": "Haiti",
    "dial": "+509"
  },
  {
    "iso": "HN",
    "name": "Honduras",
    "dial": "+504"
  },
  {
    "iso": "HK",
    "name": "Hong Kong",
    "dial": "+852"
  },
  {
    "iso": "HU",
    "name": "Hungary",
    "dial": "+36"
  },
  {
    "iso": "IS",
    "name": "Iceland",
    "dial": "+354"
  },
  {
    "iso": "IN",
    "name": "India",
    "dial": "+91"
  },
  {
    "iso": "ID",
    "name": "Indonesia",
    "dial": "+62"
  },
  {
    "iso": "IR",
    "name": "Iran",
    "dial": "+98"
  },
  {
    "iso": "IQ",
    "name": "Iraq",
    "dial": "+964"
  },
  {
    "iso": "IE",
    "name": "Ireland",
    "dial": "+353"
  },
  {
    "iso": "IM",
    "name": "Isle of Man",
    "dial": "+44"
  },
  {
    "iso": "IL",
    "name": "Israel",
    "dial": "+972"
  },
  {
    "iso": "IT",
    "name": "Italy",
    "dial": "+39"
  },
  {
    "iso": "CI",
    "name": "Ivory Coast",
    "dial": "+225"
  },
  {
    "iso": "JM",
    "name": "Jamaica",
    "dial": "+1876"
  },
  {
    "iso": "JP",
    "name": "Japan",
    "dial": "+81"
  },
  {
    "iso": "JE",
    "name": "Jersey",
    "dial": "+44"
  },
  {
    "iso": "JO",
    "name": "Jordan",
    "dial": "+962"
  },
  {
    "iso": "KZ",
    "name": "Kazakhstan",
    "dial": "+76"
  },
  {
    "iso": "KE",
    "name": "Kenya",
    "dial": "+254"
  },
  {
    "iso": "KI",
    "name": "Kiribati",
    "dial": "+686"
  },
  {
    "iso": "KW",
    "name": "Kuwait",
    "dial": "+965"
  },
  {
    "iso": "KG",
    "name": "Kyrgyzstan",
    "dial": "+996"
  },
  {
    "iso": "LA",
    "name": "Laos",
    "dial": "+856"
  },
  {
    "iso": "LV",
    "name": "Latvia",
    "dial": "+371"
  },
  {
    "iso": "LB",
    "name": "Lebanon",
    "dial": "+961"
  },
  {
    "iso": "LS",
    "name": "Lesotho",
    "dial": "+266"
  },
  {
    "iso": "LR",
    "name": "Liberia",
    "dial": "+231"
  },
  {
    "iso": "LY",
    "name": "Libya",
    "dial": "+218"
  },
  {
    "iso": "LI",
    "name": "Liechtenstein",
    "dial": "+423"
  },
  {
    "iso": "LT",
    "name": "Lithuania",
    "dial": "+370"
  },
  {
    "iso": "LU",
    "name": "Luxembourg",
    "dial": "+352"
  },
  {
    "iso": "MO",
    "name": "Macau",
    "dial": "+853"
  },
  {
    "iso": "MG",
    "name": "Madagascar",
    "dial": "+261"
  },
  {
    "iso": "MW",
    "name": "Malawi",
    "dial": "+265"
  },
  {
    "iso": "MY",
    "name": "Malaysia",
    "dial": "+60"
  },
  {
    "iso": "MV",
    "name": "Maldives",
    "dial": "+960"
  },
  {
    "iso": "ML",
    "name": "Mali",
    "dial": "+223"
  },
  {
    "iso": "MT",
    "name": "Malta",
    "dial": "+356"
  },
  {
    "iso": "MH",
    "name": "Marshall Islands",
    "dial": "+692"
  },
  {
    "iso": "MQ",
    "name": "Martinique",
    "dial": "+596"
  },
  {
    "iso": "MR",
    "name": "Mauritania",
    "dial": "+222"
  },
  {
    "iso": "MU",
    "name": "Mauritius",
    "dial": "+230"
  },
  {
    "iso": "YT",
    "name": "Mayotte",
    "dial": "+262"
  },
  {
    "iso": "MX",
    "name": "Mexico",
    "dial": "+52"
  },
  {
    "iso": "MD",
    "name": "Moldova",
    "dial": "+373"
  },
  {
    "iso": "MC",
    "name": "Monaco",
    "dial": "+377"
  },
  {
    "iso": "MN",
    "name": "Mongolia",
    "dial": "+976"
  },
  {
    "iso": "MS",
    "name": "Montserrat",
    "dial": "+1664"
  },
  {
    "iso": "MA",
    "name": "Morocco",
    "dial": "+212"
  },
  {
    "iso": "MZ",
    "name": "Mozambique",
    "dial": "+258"
  },
  {
    "iso": "NA",
    "name": "Namibia",
    "dial": "+264"
  },
  {
    "iso": "NR",
    "name": "Nauru",
    "dial": "+674"
  },
  {
    "iso": "NP",
    "name": "Nepal",
    "dial": "+977"
  },
  {
    "iso": "NL",
    "name": "Netherlands",
    "dial": "+31"
  },
  {
    "iso": "NC",
    "name": "New Caledonia",
    "dial": "+687"
  },
  {
    "iso": "NZ",
    "name": "New Zealand",
    "dial": "+64"
  },
  {
    "iso": "NI",
    "name": "Nicaragua",
    "dial": "+505"
  },
  {
    "iso": "NE",
    "name": "Niger",
    "dial": "+227"
  },
  {
    "iso": "NG",
    "name": "Nigeria",
    "dial": "+234"
  },
  {
    "iso": "NU",
    "name": "Niue",
    "dial": "+683"
  },
  {
    "iso": "NF",
    "name": "Norfolk Island",
    "dial": "+672"
  },
  {
    "iso": "KP",
    "name": "North Korea",
    "dial": "+850"
  },
  {
    "iso": "MP",
    "name": "Northern Mariana Islands",
    "dial": "+1670"
  },
  {
    "iso": "NO",
    "name": "Norway",
    "dial": "+47"
  },
  {
    "iso": "OM",
    "name": "Oman",
    "dial": "+968"
  },
  {
    "iso": "PK",
    "name": "Pakistan",
    "dial": "+92"
  },
  {
    "iso": "PW",
    "name": "Palau",
    "dial": "+680"
  },
  {
    "iso": "PA",
    "name": "Panama",
    "dial": "+507"
  },
  {
    "iso": "PG",
    "name": "Papua New Guinea",
    "dial": "+675"
  },
  {
    "iso": "PY",
    "name": "Paraguay",
    "dial": "+595"
  },
  {
    "iso": "PE",
    "name": "Peru",
    "dial": "+51"
  },
  {
    "iso": "PH",
    "name": "Philippines",
    "dial": "+63"
  },
  {
    "iso": "PN",
    "name": "Pitcairn Islands",
    "dial": "+64"
  },
  {
    "iso": "PL",
    "name": "Poland",
    "dial": "+48"
  },
  {
    "iso": "PT",
    "name": "Portugal",
    "dial": "+351"
  },
  {
    "iso": "PR",
    "name": "Puerto Rico",
    "dial": "+1787"
  },
  {
    "iso": "QA",
    "name": "Qatar",
    "dial": "+974"
  },
  {
    "iso": "MK",
    "name": "Republic of Macedonia",
    "dial": "+389"
  },
  {
    "iso": "CG",
    "name": "Republic of the Congo",
    "dial": "+242"
  },
  {
    "iso": "RO",
    "name": "Romania",
    "dial": "+40"
  },
  {
    "iso": "RU",
    "name": "Russia",
    "dial": "+7"
  },
  {
    "iso": "RW",
    "name": "Rwanda",
    "dial": "+250"
  },
  {
    "iso": "RE",
    "name": "Réunion",
    "dial": "+262"
  },
  {
    "iso": "SH",
    "name": "Saint Helena",
    "dial": "+290"
  },
  {
    "iso": "KN",
    "name": "Saint Kitts and Nevis",
    "dial": "+1869"
  },
  {
    "iso": "LC",
    "name": "Saint Lucia",
    "dial": "+1758"
  },
  {
    "iso": "PM",
    "name": "Saint Pierre and Miquelon",
    "dial": "+508"
  },
  {
    "iso": "VC",
    "name": "Saint Vincent and the Grenadines",
    "dial": "+1784"
  },
  {
    "iso": "WS",
    "name": "Samoa",
    "dial": "+685"
  },
  {
    "iso": "SM",
    "name": "San Marino",
    "dial": "+378"
  },
  {
    "iso": "SA",
    "name": "Saudi Arabia",
    "dial": "+966"
  },
  {
    "iso": "SN",
    "name": "Senegal",
    "dial": "+221"
  },
  {
    "iso": "RS",
    "name": "Serbia",
    "dial": "+381"
  },
  {
    "iso": "SC",
    "name": "Seychelles",
    "dial": "+248"
  },
  {
    "iso": "SL",
    "name": "Sierra Leone",
    "dial": "+232"
  },
  {
    "iso": "SG",
    "name": "Singapore",
    "dial": "+65"
  },
  {
    "iso": "SK",
    "name": "Slovakia",
    "dial": "+421"
  },
  {
    "iso": "SI",
    "name": "Slovenia",
    "dial": "+386"
  },
  {
    "iso": "SB",
    "name": "Solomon Islands",
    "dial": "+677"
  },
  {
    "iso": "SO",
    "name": "Somalia",
    "dial": "+252"
  },
  {
    "iso": "ZA",
    "name": "South Africa",
    "dial": "+27"
  },
  {
    "iso": "GS",
    "name": "South Georgia",
    "dial": "+500"
  },
  {
    "iso": "KR",
    "name": "South Korea",
    "dial": "+82"
  },
  {
    "iso": "SS",
    "name": "South Sudan",
    "dial": "+211"
  },
  {
    "iso": "ES",
    "name": "Spain",
    "dial": "+34"
  },
  {
    "iso": "LK",
    "name": "Sri Lanka",
    "dial": "+94"
  },
  {
    "iso": "SD",
    "name": "Sudan",
    "dial": "+249"
  },
  {
    "iso": "SR",
    "name": "Suriname",
    "dial": "+597"
  },
  {
    "iso": "SJ",
    "name": "Svalbard and Jan Mayen",
    "dial": "+4779"
  },
  {
    "iso": "SZ",
    "name": "Swaziland",
    "dial": "+268"
  },
  {
    "iso": "SE",
    "name": "Sweden",
    "dial": "+46"
  },
  {
    "iso": "CH",
    "name": "Switzerland",
    "dial": "+41"
  },
  {
    "iso": "SY",
    "name": "Syria",
    "dial": "+963"
  },
  {
    "iso": "ST",
    "name": "São Tomé and Príncipe",
    "dial": "+239"
  },
  {
    "iso": "TW",
    "name": "Taiwan",
    "dial": "+886"
  },
  {
    "iso": "TJ",
    "name": "Tajikistan",
    "dial": "+992"
  },
  {
    "iso": "TZ",
    "name": "Tanzania",
    "dial": "+255"
  },
  {
    "iso": "TH",
    "name": "Thailand",
    "dial": "+66"
  },
  {
    "iso": "BS",
    "name": "The Bahamas",
    "dial": "+1242"
  },
  {
    "iso": "GM",
    "name": "The Gambia",
    "dial": "+220"
  },
  {
    "iso": "TG",
    "name": "Togo",
    "dial": "+228"
  },
  {
    "iso": "TK",
    "name": "Tokelau",
    "dial": "+690"
  },
  {
    "iso": "TO",
    "name": "Tonga",
    "dial": "+676"
  },
  {
    "iso": "TT",
    "name": "Trinidad and Tobago",
    "dial": "+1868"
  },
  {
    "iso": "TN",
    "name": "Tunisia",
    "dial": "+216"
  },
  {
    "iso": "TR",
    "name": "Turkey",
    "dial": "+90"
  },
  {
    "iso": "TM",
    "name": "Turkmenistan",
    "dial": "+993"
  },
  {
    "iso": "TV",
    "name": "Tuvalu",
    "dial": "+688"
  },
  {
    "iso": "UG",
    "name": "Uganda",
    "dial": "+256"
  },
  {
    "iso": "UA",
    "name": "Ukraine",
    "dial": "+380"
  },
  {
    "iso": "AE",
    "name": "United Arab Emirates",
    "dial": "+971"
  },
  {
    "iso": "GB",
    "name": "United Kingdom",
    "dial": "+44"
  },
  {
    "iso": "US",
    "name": "United States",
    "dial": "+1"
  },
  {
    "iso": "UY",
    "name": "Uruguay",
    "dial": "+598"
  },
  {
    "iso": "UZ",
    "name": "Uzbekistan",
    "dial": "+998"
  },
  {
    "iso": "VU",
    "name": "Vanuatu",
    "dial": "+678"
  },
  {
    "iso": "VE",
    "name": "Venezuela",
    "dial": "+58"
  },
  {
    "iso": "VN",
    "name": "Vietnam",
    "dial": "+84"
  },
  {
    "iso": "WF",
    "name": "Wallis and Futuna",
    "dial": "+681"
  },
  {
    "iso": "EH",
    "name": "Western Sahara",
    "dial": "+212"
  },
  {
    "iso": "YE",
    "name": "Yemen",
    "dial": "+967"
  },
  {
    "iso": "ZM",
    "name": "Zambia",
    "dial": "+260"
  },
  {
    "iso": "ZW",
    "name": "Zimbabwe",
    "dial": "+263"
  }
];
